import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function MaterialsMenu(props) {
  return (
    <Dropdown
      menuKey="materials"
      menu={projectMenus.materials}
      {...props}
    />
  );
}
